import {
  RBAC_DEVICE_LIST_VIEW_PERMISSIONS,
  RbacPermissions,
} from './rbac-permissions';

/**
 * Legacy umbrella permissions that grant the listed granular permissions.
 * UserMgmt_* and OTA_* umbrellas removed in dev — roles use granular keys only.
 */
export const LEGACY_PERMISSION_GRANTS: Readonly<Record<string, readonly string[]>> = {
  [RbacPermissions.DeviceList_BulkEdit]: [RbacPermissions.DeviceList_View],
  [RbacPermissions.DeviceList_Edit_ActionCol]: [RbacPermissions.DeviceList_View],
  [RbacPermissions.DeviceList_Export_Button]: [RbacPermissions.DeviceList_View],
};

/** Alternate BE permission keys that satisfy the same check. */
export const PERMISSION_ALIASES: Readonly<Record<string, readonly string[]>> = {
  [RbacPermissions.OTA_UploadConfigurationFile]: [
    RbacPermissions.OTA_UploadConfigurationFile,
    'OTA_UplodConfigurationFile',
  ],
  [RbacPermissions.DeviceList_View]: [
    RbacPermissions.DeviceList_View,
    ...RBAC_DEVICE_LIST_VIEW_PERMISSIONS.filter(
      (key) => key !== RbacPermissions.DeviceList_View
    ),
  ],
};
